"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "maskKnexConfig", {
    enumerable: true,
    get: function() {
        return maskKnexConfig;
    }
});
function maskKnexConfig(payload) {
    /*
    remove password from knex config
  */ if (payload.config && payload.config.connection && payload.config.connection.password) {
        payload.config.connection.password = null;
    }
    return payload;
}
